import { createContext } from 'react';

import { SignalRState, initialState } from './state';

const SignalRContext = createContext<SignalRState>(initialState);

export default SignalRContext;
